<template>
  <div>
    <travel-service-menu />

    <h1>{{ $t("settings.travelService.offerAcceptance") }}</h1>

    <v-row no-gutters>
      <v-spacer />
      <v-col cols="12" md="4">
        <v-row no-gutters>
          <v-autocomplete :items="availableUsersSelect" :label="$t('global.user')" v-model="selectedUser" />
          <v-btn @click="addUser" class="success ml-4">
            {{ $t("global.add") }}
          </v-btn>
        </v-row>
      </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="approvalUsers">
      <template #item="props">
        <tr>
          <td class="text-left">
            {{
              typeof availableUsers.find(v => v.id === props.item.user_id) !== "undefined" ? availableUsers.find(v => v.id === props.item.user_id).name : null
            }}
          </td>
          <td class="text-left">
            {{
              typeof availableUsers.find(v => v.id === props.item.user_id) !== "undefined"
                ? availableUsers.find(v => v.id === props.item.user_id).surname
                : null
            }}
          </td>
          <td class="text-left">
            {{
              typeof availableUsers.find(v => v.id === props.item.user_id) !== "undefined" ? availableUsers.find(v => v.id === props.item.user_id).login : null
            }}
          </td>
          <td class="text-left">
            {{
              typeof availableUsers.find(v => v.id === props.item.user_id) !== "undefined" ? availableUsers.find(v => v.id === props.item.user_id).email : null
            }}
          </td>
          <td class="text-center">
            <v-tooltip bottom>
              {{ $t("global.delete") }}
              <template #activator="{on}">
                <v-btn v-on="on" @click="remove(props.item)" icon>
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <v-alert slot="no-data" :value="loaded" color="info" icon="info">
        {{ $t("settings.travelService.noAcceptancePersons") }}
      </v-alert>
    </v-data-table>

    <v-alert color="info" dark :value="approvalUsers.length > 0" icon="info">
      {{ $t("settings.travelService.automaticApprovalInfo") }}
    </v-alert>
  </div>
</template>

<script>
import TravelServiceMenu from "../../../components/Settings/TravelService/TravelServiceMenu";
export default {
  name: "SettingsTravelServiceView",
  components: { TravelServiceMenu },
  data: () => ({
    approvalUsers: [],
    availableUsers: [],
    selectedUser: null,
    loaded: false
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("settings.users.fields.name.name"), value: "name" },
        {
          text: this.$t("settings.users.fields.surname.name"),
          value: "surname"
        },
        { text: this.$t("settings.users.fields.login.name"), value: "login" },
        { text: this.$t("settings.users.fields.email.name"), value: "email" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    },
    availableUsersSelect() {
      let users = [];
      for (let user of this.availableUsers) {
        users.push({
          text: user.name + " " + user.surname + " (" + user.login + ")",
          value: user.id
        });
      }
      return users;
    }
  },
  created() {
    this.axios.get("/settings/travel-service/get-available-users").then(resp => {
      this.availableUsers = resp.data;
    });
    this.downloadApprovalUsers();
  },
  methods: {
    downloadApprovalUsers() {
      this.axios.get("/settings/travel-service/get-approval-users").then(resp => {
        this.approvalUsers = resp.data;
        this.loaded = true;
      });
    },
    addUser() {
      this.axios
        .post("/settings/travel-service/add-approval-user", {
          user_id: this.selectedUser
        })
        .then(() => {
          this.downloadApprovalUsers();
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.saved"),
            position: "down"
          });
        });
    },
    remove(item) {
      let dialog = this.$store.dispatch("confirmDialog", {
        content: this.$t("settings.travelService.removeDialog.content"),
        title: this.$t("settings.travelService.removeDialog.title")
      });
      dialog
        .then(() => {
          this.axios
            .post("/settings/travel-service/delete-approval-user", {
              user_id: item.user_id
            })
            .then(() => {
              this.downloadApprovalUsers();
              this.$store.dispatch("AUTH_UPDATE_SETTINGS").then(() => {
                this.$store.dispatch("snackbarPush", {
                  text: this.$t("settings.travelService.removeDialog.snackbar"),
                  position: "down"
                });
              });
            });
        })
        .catch(resp => {
          if (typeof resp !== "undefined") {
            console.log(resp);
          }
        });
    }
  }
};
</script>

<style scoped></style>
